import React, { useState } from 'react';
import { Link } from 'gatsby';
import * as styles from './aiEngineerFellowship.module.scss';
import PostContentCTALayout from '@components/v5/layouts/PostContentCTALayout/index';
import LeadGenerationButton from '@components/LeadGenerationForm/LeadGenerationButton';
import CrioButton from '@components/v5/CrioButton/index';
import { LEAD_GEN_CURRICULUM } from '@src/constants/LeadGenerationConstants/index';

const Curriculum = ({ content, compact }) => {
  const { sprints, dsaModules, systemDesignModules } = content;
  const [active, setActive] = useState(0);
  const sprint = sprints[active];

  return (
    <section id="curriculum" className={styles.mint}>
      <div className={styles.wrap}>
        <div className={styles.shead}>
          <span className={styles.eyebrow}>Curriculum</span>
          <h2>The Curriculum To Crack AI Engineer Roles</h2>
          <p>
            Six 4-week sprints followed by a 2-week Interview Preparation
            Sprint. Each sprint: 10 live sessions (2 hrs) + ~20 hrs of take-home
            builds, ending in a demo day. Click a sprint to see what you&apos;ll
            learn and ship.
          </p>
        </div>

        <div className={styles.curr}>
          <div className={styles.clist} role="tablist" aria-label="Sprints">
            {sprints.map((s, index) => (
              <button
                type="button"
                role="tab"
                key={s.id}
                aria-selected={index === active}
                className={`${styles.citem} ${
                  index === active ? styles.active : ''
                }`}
                onClick={() => setActive(index)}
              >
                <div
                  className={`${styles.cico} ${s.highlight ? styles.s : ''}`}
                >
                  {s.id}
                </div>
                <div>
                  <h4>{s.title}</h4>
                  <div className={styles.wk}>{s.wk}</div>
                </div>
              </button>
            ))}
          </div>
          <div className={styles.cdetail} role="tabpanel">
            <h3>{sprint.title}</h3>
            <div className={styles.cw}>{sprint.wk}</div>
            <p className={styles.lead}>{sprint.lead}</p>
            <ul>
              {sprint.pts.map((pt) => (
                <li key={pt}>{pt}</li>
              ))}
            </ul>
            <div className={styles.ship}>
              <b>You ship:</b> {sprint.ship}
            </div>
            <div className={styles.kchips}>
              {sprint.chips.map((chip) => (
                <span className={styles.kchip} key={chip}>
                  {chip}
                </span>
              ))}
            </div>
          </div>
        </div>

        <p className={styles.note}>
          Sprint contents and project sequencing may be refined with industry
          experts before the cohort starts.
        </p>

        {!compact && (
          <>
            <div className={styles.clabel}>
              Optional · Self-paced modules — included
            </div>
            <div className={styles.optgrid}>
              <div className={styles.optcard}>
                <h4>Data Structures &amp; Algorithms</h4>
                <div className={styles.sub}>
                  300+ problems on the platform with guided session recordings
                </div>
                <ul>
                  {dsaModules.map((m) => (
                    <li key={m.name}>
                      <span>{m.name}</span>
                      <span>{m.dur}</span>
                    </li>
                  ))}
                </ul>
              </div>
              <div className={styles.optcard}>
                <h4>System Design</h4>
                <div className={styles.sub}>
                  Low-level and high-level design with hands-on scenarios
                </div>
                <ul>
                  {systemDesignModules.map((m) => (
                    <li key={m.name}>
                      <span>{m.name}</span>
                      <span>{m.dur}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <PostContentCTALayout className="mt-8 sm:mt-8">
              <Link to="/ai-engineering/view-brochure/">
                <CrioButton variant="secondary">View Curriculum</CrioButton>
              </Link>
              <LeadGenerationButton
                text="Apply Now"
                buttonLocation={LEAD_GEN_CURRICULUM}
              />
            </PostContentCTALayout>
          </>
        )}
      </div>
    </section>
  );
};

export default Curriculum;
